import React from 'react';
import { accountState, isAccountModalState } from '../../recoil/atoms';
import { useRecoilValue, useSetRecoilState } from 'recoil';

const SelectAccountButton = () => {
  const account = useRecoilValue(accountState);
  const setIsAccountModalOpen = useSetRecoilState(isAccountModalState);
  const environment = process.env.NODE_ENV;
  return (
    <button
      className={`flex items-center justify-center gap-x-1 text-2xs sm:text-sm rounded my-auto w-8/12 font-semibold ml-34 shadow-md h-1/6 sm:h-full ${
        environment === 'production' && 'py-3'
      } bg-gray-200 hover:bg-gray-300 text-black`}
      onClick={() => setIsAccountModalOpen(true)}
    >
      <p
        className={`${
          environment === 'development' ? 'mt-3' : ''
        } hidden sm:inline`}
      >
        Selected Account:
      </p>{' '}
      <p className={environment === 'development' ? 'mt-3' : ''}>
        {account.name}
      </p>
    </button>
  );
};

export default SelectAccountButton;
